module.exports = __webpack_public_path__ + "static/media/tools.6ae2d0d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tools.png
// module id = 811
// module chunks = 0